export default __webpack_public_path__ + "static/media/lock-colour.2914c6c3.svg";